export enum StorageKey {
    FilterSelector = 'FILTER_SELECTOR',
}
